export const ALL_COMPANIES = 'ALL_COMPANIES'
export const ALL_FRANCHISES = 'ALL_FRANCHISES'
